import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-502aa12f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resource-purchase" }
const _hoisted_2 = { class: "rp_wrap" }
const _hoisted_3 = { class: "rp_main" }
const _hoisted_4 = {
  key: 0,
  class: "rp_good_list"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"rp_good_tr head\" data-v-502aa12f><div class=\"rp_good_td\" data-v-502aa12f>配置详情</div><div class=\"rp_good_td\" data-v-502aa12f>数量</div><div class=\"rp_good_td\" data-v-502aa12f>时长</div><div class=\"rp_good_td\" data-v-502aa12f>生效时间</div><div class=\"rp_good_td\" data-v-502aa12f>总额</div></div>", 1)
const _hoisted_6 = { class: "rp_good_tr" }
const _hoisted_7 = { class: "rp_good_td" }
const _hoisted_8 = { class: "rp_good_td" }
const _hoisted_9 = { class: "rp_good_td" }
const _hoisted_10 = { class: "rp_good_td" }
const _hoisted_11 = { class: "rp_good_td" }
const _hoisted_12 = {
  key: 1,
  class: "rp_good_list"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rp_good_tr head" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "rp_good_td" }, "商品名称"),
  /*#__PURE__*/_createElementVNode("div", { class: "rp_good_td" }, "有效期"),
  /*#__PURE__*/_createElementVNode("div", { class: "rp_good_td" }, "金额")
], -1))
const _hoisted_14 = { class: "rp_good_td" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rp_good_td" }, "一年", -1))
const _hoisted_16 = { class: "rp_good_td" }
const _hoisted_17 = { class: "balance_info" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "balance_info_name" }, "账户余额：", -1))
const _hoisted_19 = { style: {"color":"#fa5555","font-size":"16px"} }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"14px","margin":"4px 0 0 5px"} }, "元", -1))
const _hoisted_21 = { class: "recharge_content" }
const _hoisted_22 = { class: "recharge_content_radio" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_radio_name" }, "支付方式：", -1))
const _hoisted_24 = { class: "radio_button_content" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "content_text" }
const _hoisted_27 = { class: "content_text_name" }
const _hoisted_28 = { class: "content_text_english" }
const _hoisted_29 = { class: "rp_form_sub" }
const _hoisted_30 = { class: "rp_form_sub_pay" }
const _hoisted_31 = { class: "wxpay_modal" }
const _hoisted_32 = { style: {"font-size":"20px","font-weight":"bold","color":"#333333","text-align":"center"} }
const _hoisted_33 = { style: {"width":"227px","margin":"10px auto","text-align":"center"} }
const _hoisted_34 = ["src"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#666666","font-size":"14px","font-weight":"500","text-align":"center"} }, "请用微信扫码支付", -1))
const _hoisted_36 = { class: "recharge_Alipay" }
const _hoisted_37 = ["src"]
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "recharge_Alipay_text" }
const _hoisted_40 = { class: "recharge_Alipay_detailed" }
const _hoisted_41 = { class: "Alipay_detailed_line" }
const _hoisted_42 = { class: "Alipay_detailed_line" }
const _hoisted_43 = { class: "Alipay_detailed_line" }
const _hoisted_44 = { style: {"font-size":"16px"} }
const _hoisted_45 = { style: {"width":"100%","text-align":"center","margin-top":"50px","padding-bottom":"70px"} }

import { Radio, Modal, Spin, message } from 'ant-design-vue';
import { numberToCurrency } from '@/utils/format/number';
import { LoadingOutlined, ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { useQRCode } from '@vueuse/integrations/useQRCode';

// `qrcode` will be a ref of data URL
import { computed, createVNode, reactive, ref } from 'vue';
import type { PayTypeOption, ResourcePkg, Version } from './types';
import { Balancepay, WeChatpay, sucMsg, failMsg } from '@/assets';
import { useRoute, useRouter } from 'vue-router';
import http from '@/api/account';
import axios from '@/api/resource';
import { useDebounce } from '@/hooks/useDebounce';
import { getToken } from '@/plugins/cookie';

const __default__ = { name: 'Pay' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter();
const aRadioGroup = Radio.Group;
const aRadioButton = Radio.Button;
const aModal = Modal;
const aSpin = Spin;
const route = useRoute();
const parentPage = [
  {
    id: 1,
    routeName: '/wallet/resource',
  },
  {
    id: 2,
    routeName: '/wallet/version',
  },
];
const payTypeList: PayTypeOption[] = [
  // {
  //   payId: 2,
  //   cname: '支付宝',
  //   name: 'ALIPAY',
  //   img: Alipay
  // },
  {
    payId: 1,
    cname: '微信支付',
    name: 'WECHAT PAY',
    img: WeChatpay,
  },
  {
    payId: 3,
    cname: '余额支付',
    name: 'BALANCE PAY',
    img: Balancepay,
  },
];

const rechargeConfig = reactive({
  content: true, // 充值界面显示
  success: false, // 充值结果状态

  formPrice: 0,
  payType: 1, // 支付类型
  balance: '', // 余额
  rechargeStatus: false, // 是否阅读规则
  visableRules: false, // 充值规则显示
  errMsg: '很抱歉，支付失败！',

  weChatModal: false, // 二维码生成弹框
});
const nextBtn = ref(true);

const urlParam = computed(() => (route.params.goods_id as string).split('-').map(Number));
const formatFormPrice = ref();
const goodList = ref<Version[]>([]);
const getVersionGoods = async () => {
  try {
    const res: any = await http.getVsersionList({
      params: {
        version_id: urlParam.value[1],
        web_data: 1,
      },
    });
    goodList.value = [].concat(res.data.data);
    formatFormPrice.value = numberToCurrency(goodList.value[0].role_info.price);
    nextBtn.value = false;
  } catch (e) {
    console.error(e);
  }
};

const pkgGood = ref<ResourcePkg>();
const getResourcePkg = () => {
  const data = {
    id: urlParam.value[1],
    term_type: route.query.term_type,
    count: route.query.count,
    start_at: route.query.start_at,
  };
  axios.payPackageInfo({ params: data }).then((res) => {
    pkgGood.value = res.data.data;
    formatFormPrice.value = numberToCurrency(pkgGood.value?.amount ?? 0);
    nextBtn.value = false;
  });
};

const getBalance = () => {
  http
    .getTheRemainingBalance()
    .then((res) => {
      rechargeConfig.balance = numberToCurrency(parseFloat(res.data.data.balance).toFixed(2));
    })
    .catch((err) => {
      console.error(err);
    });
};

// 返回
const payBack = () => {
  if (rechargeConfig.success) {
    router.replace({ name: 'Home' });
  } else {
    rechargeConfig.content = true;
  }
};

const callBackData = reactive<{
  wxCode: string;
  order: string;
  orderTimer: any;
}>({
  wxCode: '',
  order: '',
  orderTimer: '',
});
const clearWXcode = () => {
  clearInterval(callBackData.orderTimer);
  callBackData.wxCode = '';
  rechargeConfig.weChatModal = false;
};
const indicator = createVNode(LoadingOutlined, {
  style: {
    fontSize: '24px',
  },
  spin: true,
});

const pkgWechatPay = () => {
  http
    .payPackageCreateOrder({
      key: pkgGood.value?.key,
      pay_type: rechargeConfig.payType,
      token: getToken(),
    })
    // 生成订单号
    .then((res) => {
      rechargeConfig.weChatModal = true;
      callBackData.order = res.data.data.order_no;
      clearInterval(callBackData.orderTimer);
      return http.weChatScanPay({
        params: {
          order_no: res.data.data.order_no,
          pay_type: 5, // 接口特定参数，表资源包购买
        },
      });
    })
    // 生成支付二维码
    .then((resRQcode: any) => {
      callBackData.wxCode = resRQcode.data.data; //获取二维码
      callBackData.orderTimer = setInterval(() => {
        // 轮询订单状态
        http
          .packagePollingOrder({
            params: {
              token: getToken(),
              order_no: callBackData.order,
            },
          })
          .then((res) => {
            //     // 查询余额
            if (res.data.data.code != 40003) {
              getBalance();
              clearWXcode();
              // 付费后资源分配
              http
                .packageBalanceChange({
                  token: getToken(),
                  order_no: callBackData.order,
                })
                .then(() => {
                  rechargeConfig.success = true;
                  setTimeout(() => {
                    payBack();
                  }, 3000);
                })
                .catch((res) => {
                  rechargeConfig.success = false;
                  rechargeConfig.errMsg = res.data.error && res.data.error;
                })
                .finally(() => {
                  rechargeConfig.content = false;
                });
            }
          })
          .catch((res) => {
            rechargeConfig.success = false;
            rechargeConfig.content = false;
            rechargeConfig.errMsg = res.data.error && res.data.error;
          });
      }, 1000);
    })
    .catch((res) => {
      res.data.error ? message.error(res.data.error) : '';
    });
};
const versionWechatPay = () => {
  http
    .versionPurchaseUpgrade({
      version_id: urlParam.value[1],
      pay_type: rechargeConfig.payType,
      token: getToken(),
    })
    // 生成订单号
    .then((res) => {
      rechargeConfig.weChatModal = true;
      callBackData.order = res.data.data.order_no;
      clearInterval(callBackData.orderTimer);
      return http.weChatScanPay({
        params: {
          order_no: res.data.data.order_no,
          pay_type: 6, // 接口特定参数，表版本升级
        },
      });
    })
    // 生成支付二维码
    .then((resRQcode: any) => {
      callBackData.wxCode = resRQcode.data.data; //获取二维码
      callBackData.orderTimer = setInterval(() => {
        // 轮询订单状态
        http
          .pollingOrder({
            params: {
              token: getToken(),
              order_no: callBackData.order,
            },
          })
          .then((res) => {
            //     // 查询余额
            if (res.data.data.code != 40003) {
              getBalance();
              clearWXcode();
              http
                .versionPurchaseCallback({
                  params: {
                    token: getToken(),
                    order_no: callBackData.order,
                    pay_type: rechargeConfig.payType,
                  },
                })
                .then(() => {
                  rechargeConfig.success = true;
                  setTimeout(() => {
                    payBack();
                  }, 3000);
                })
                .catch((res) => {
                  rechargeConfig.success = false;
                  rechargeConfig.errMsg = res.data.error && res.data.error;
                })
                .finally(() => {
                  rechargeConfig.content = false;
                });
            }
          })
          .catch((res) => {
            rechargeConfig.success = false;
            rechargeConfig.content = false;
            rechargeConfig.errMsg = res.data.error && res.data.error;
          });
      }, 1000);
    })
    .catch((err) => {
      message.warning('网络异常,请稍后重试！');
    });
};

const weChatPay = () => {
  switch (urlParam.value[0]) {
    case 0:
      pkgWechatPay();
      break;
    case 1:
      versionWechatPay();
      break;
  }
};

const pkgBalancePay = () => {
  http
    .payPackageCreateOrder({
      key: pkgGood.value?.key,
      pay_type: rechargeConfig.payType,
      token: getToken(),
    })
    // 余额支付
    .then((res) => {
      // this.confirmVisible = false
      // 查询余额
      getBalance();
      rechargeConfig.success = true;
      setTimeout(() => {
        payBack();
      }, 3000);
    })
    .catch((res) => {
      rechargeConfig.success = false;
      rechargeConfig.errMsg = res.data.error && res.data.error;
    })
    .finally(() => {
      rechargeConfig.content = false;
    });
};

const versionBalancePay = () => {
  http
    .versionPurchaseUpgrade({
      version_id: urlParam.value[1],
      pay_type: rechargeConfig.payType,
      token: getToken(),
    })
    // 余额支付
    .then((res) => {
      // this.confirmVisible = false
      // 查询余额
      getBalance();
      rechargeConfig.success = true;
      setTimeout(() => {
        payBack();
      }, 3000);
    })
    .catch((res) => {
      rechargeConfig.success = false;
      rechargeConfig.errMsg = res.data.error && res.data.error;
    })
    .finally(() => {
      rechargeConfig.content = false;
    });
};
const balancePay = () => {
  switch (urlParam.value[0]) {
    case 0:
      pkgBalancePay();
      break;
    case 1:
      versionBalancePay();
      break;
  }
};

const subPay = useDebounce(() => {
  Modal.confirm({
    centered: true,
    content: () => '是否确定支付?',
    icon: () => createVNode(ExclamationCircleOutlined),
    onOk() {
      return new Promise((resolve, reject) => {
        switch (rechargeConfig.payType) {
          case 1:
            weChatPay();
            return resolve({});
          case 2:
            // 支付宝
            break;
          case 3:
            // 余额支付
            balancePay();
            return resolve({});
        }
      }).catch(() => console.log('Oops errors!'));
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onCancel() {},
  });
});

const init = () => {
  switch (urlParam.value[0]) {
    case 0:
      getResourcePkg();
      break;
    case 1:
      getVersionGoods();
      break;
  }
  getBalance();
};
init();

const url = computed(() => callBackData.wxCode);
const qrcode = useQRCode(url, { margin: 0 });

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("div", null, [
          (_unref(urlParam)[0] === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("p", null, "资源包类型：" + _toDisplayString(pkgGood.value?.package_type_name), 1),
                    _createElementVNode("p", null, "资源包名称：" + _toDisplayString(pkgGood.value?.package_name), 1),
                    _createElementVNode("p", null, "资源包容量：" + _toDisplayString(pkgGood.value?.number) + _toDisplayString(pkgGood.value?.unit), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(pkgGood.value?.count), 1),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(pkgGood.value?.term_name), 1),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(route).query.start_at), 1),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(numberToCurrency)(pkgGood.value?.amount ? pkgGood.value?.amount : 0)), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(urlParam)[0] === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goodList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "rp_good_tr",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(item.role_info.role_type), 1),
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(numberToCurrency)(item.role_info.price)), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("span", null, [
              _createElementVNode("span", _hoisted_19, "￥" + _toDisplayString(rechargeConfig.balance), 1),
              _hoisted_20
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode(_unref(aRadioGroup), {
                value: rechargeConfig.payType,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((rechargeConfig.payType) = $event)),
                class: "content_radio_button"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(payTypeList, (item, index) => {
                    return _createVNode(_unref(aRadioButton), {
                      class: "radio_button",
                      value: item.payId,
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("img", {
                            class: "content_img",
                            src: item.img
                          }, null, 8, _hoisted_25),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, _toDisplayString(item.cname), 1),
                            _createElementVNode("div", _hoisted_28, _toDisplayString(item.name), 1)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_router_link, {
                to: parentPage[_unref(urlParam)[0]].routeName
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, { class: "rfsp_reset" }, {
                    default: _withCtx(() => [
                      _createTextVNode("取消")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"]),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _unref(subPay),
                disabled: nextBtn.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode("支付")
                ]),
                _: 1
              }, 8, ["onClick", "disabled"])
            ])
          ])
        ], 512), [
          [_vShow, rechargeConfig.content]
        ]),
        _createVNode(_unref(aModal), {
          visible: rechargeConfig.weChatModal,
          "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((rechargeConfig.weChatModal) = $event)),
          title: "收银台",
          centered: "",
          onCancel: _cache[2] || (_cache[2] = ($event: any) => (clearWXcode())),
          footer: null
        }, {
          footer: _withCtx(() => [
            _withDirectives(_createVNode(_component_a_button, { key: "back" }, null, 512), [
              [_vShow, !rechargeConfig.weChatModal]
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, _toDisplayString(formatFormPrice.value) + "元", 1),
              _createElementVNode("div", _hoisted_33, [
                (!callBackData.wxCode)
                  ? (_openBlock(), _createBlock(_unref(aSpin), {
                      key: 0,
                      style: {"width":"50px","margin":"50px auto"},
                      indicator: _unref(indicator)
                    }, null, 8, ["indicator"]))
                  : _createCommentVNode("", true),
                (_unref(qrcode))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      style: {"width":"150px"},
                      src: _unref(qrcode),
                      alt: "QR Code"
                    }, null, 8, _hoisted_34))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_35
            ])
          ]),
          _: 1
        }, 8, ["visible"]),
        _withDirectives(_createElementVNode("div", _hoisted_36, [
          (rechargeConfig.success)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "recharge_Alipay_img",
                src: _unref(sucMsg),
                alt: ""
              }, null, 8, _hoisted_37))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: "recharge_Alipay_img",
                src: _unref(failMsg),
                alt: ""
              }, null, 8, _hoisted_38)),
          _createElementVNode("div", _hoisted_39, _toDisplayString(rechargeConfig.success ? '支付成功' : rechargeConfig.errMsg), 1),
          _withDirectives(_createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, "账户余额：" + _toDisplayString(rechargeConfig.balance), 1),
            _createElementVNode("div", _hoisted_42, "可用余额：" + _toDisplayString(rechargeConfig.balance), 1),
            _createElementVNode("div", _hoisted_43, [
              _createTextVNode(" 购买金额： "),
              _createElementVNode("div", _hoisted_44, _toDisplayString(formatFormPrice.value) + " 元", 1)
            ])
          ], 512), [
            [_vShow, rechargeConfig.success]
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (payBack()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(rechargeConfig.success ? '确定' : '返回支付页面'), 1)
              ]),
              _: 1
            })
          ])
        ], 512), [
          [_vShow, !rechargeConfig.content]
        ])
      ])
    ])
  ]))
}
}

})